import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 05435BA8-4BB4-4581-A2BA-D2D7679B831F
 * name fast-forward-outline
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fast-forward-outline.svg
 * tags
 */
export const FastForwardOutlineIcon = createSvgIcon(<><path d="M15,9.9L18,12L15,14.1V9.9M6,9.9L9,12L6,14.1V9.9M13,6V18L21.5,12L13,6M4,6V18L12.5,12L4,6Z" /></>, 'FastForwardOutlineIcon');
export default FastForwardOutlineIcon